import { isModernBridge } from '@/common/bridge/mode';

import * as CommsService from '../comms.service';
import { CommsCommand } from '../comms.enum';

/**
 * Push the visitor's live (agent) chat state to the loader so `get:is_chatting`
 * can return it synchronously. No-op outside modern SDK bridge mode, mirroring
 * how open state is reported via `bot:set_open`.
 */
export function postChattingState(isChatting: boolean): void {
  if (!isModernBridge()) {
    return;
  }

  CommsService.post(CommsCommand.bot.setChatting, isChatting);
}
